/**
 * Display a choice with a picture, a name, description and price
 * shape parameter allow to show image as a cicle or a square
 */
fx.ns("shared.components", class OptionChoice extends fx.components.VBox {
    constructor(shape, data, image, name, description, price, favorite, premium) {
        super();

        this.data = data;
        this.image = image;
        this.name = name;
        this.description = description;
        this.price = price;
        this.favorite = favorite;
        this.premium = premium;

        this._display = shape || "circle";
    }

    create() {
        super.create();

        this.addChild(new fx.components.Image({ data: this.image, className: "optionImage" }), { width: "100%", height: fx.browser.isDesktop ? 230 : 330, left: "center" });

        if (this.premium) {
            this.addChild(new fx.components.Text({ text: "Qualité Premium", className: "premiumText" }), { width: "auto", height: "auto", right: 10, top: 10 });
            let favoriteRow = new fx.components.HBox("boxFavoritePremium");
            favoriteRow.addChild(new fx.components.Text({ text: "Notre coup de ", className: "favoritePremiumText" }), { width: "auto", height: "auto" });
            favoriteRow.addChild(new fx.components.Image({ data: fx.assets.heartIcon, className: "favoritePremiumIcon" }), { width: 24, height: "auto", top: 0 });
            if (fx.browser.isDesktop)
                this.addChild(favoriteRow, { width: "auto", height: 25, right: 20, top: 190 });
            else if (fx.browser.isMobile)
                this.addChild(favoriteRow, { width: "auto", height: 25, right: 0, top: 175 });
        }
        else if (this.favorite) {
            let favoriteRow = new fx.components.HBox("boxFavorite");
            favoriteRow.addChild(new fx.components.Text({ text: "Coup de ", className: "favoriteText" }), { width: "auto", height: "auto" });
            favoriteRow.addChild(new fx.components.Image({ data: fx.assets.heartIcon, className: "favoriteIcon" }), { width: 24, height: "auto", top: 0 });
            this.addChild(favoriteRow, { width: "auto", height: 25, right: 10, top: 10 });
        }

        if (this.name)
            this.addChild(new fx.components.Text({ text: this.name, className: "name" }), { width: "90%", height: "auto", left: "center" });

        if (this.description)
            this.addChild(new fx.components.Text({ text: this.description, className: "description" }), { width: "90%", left: "center" });

        this.row = new fx.components.HBox("boxFooter");
        if (this.price)
            this.row.addChild(new fx.components.Text({ text: "+" + this.price.toFixed(2) + " €", className: "price" }), { width: 190, left: 10 });

        this.unchecked = new fx.components.ImageButton({ image: fx.assets.checkbox_unckecked });
        this.checked = new fx.components.ImageButton({ image: fx.assets.checkbox_checked });
        this.row.addChild(this.unchecked, { width: 24, height: 24, right: 20 });
        this.row.addChild(this.checked, { width: 24, height: 24, right: 20 });
        this.checked.visibleAtStart = false;

        this.addChild(this.row, { bottom: 20, width: "100%", height: 24 });
        this.addClass(this._display);
    }

    setChecked(checked) {
        this.unchecked.visible = !checked;
        this.checked.visible = checked;
    }

});
